// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductRating.module.scss  */
.ProductRating-module-Root_1oS {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 4px 12px 4px 0;
  border-radius: 0 8px 8px 0;
  background-color: #fff;
  transform: translateY(50%); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Rating/ProductRating.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B,EAAE","sourcesContent":["/*  imported from ProductRating.module.scss  */\n.ProductRating-module-Root_1oS {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 4px 12px 4px 0;\n  border-radius: 0 8px 8px 0;\n  background-color: #fff;\n  transform: translateY(50%); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
